module.exports = __webpack_public_path__ + "img/rellx_exwz2n.354a89d8.png";